// extracted by mini-css-extract-plugin
export var attachment = "_im-a";
export var emailContainer = "_im-4";
export var emailContentPaddedContainer = "_im-b";
export var emailHeader = "_im-6";
export var emailIframe = "_im-3";
export var emailInfoIcon = "_im-9";
export var emailShortenedSummary = "_im-e";
export var infoDropdown = "_im-0";
export var infoRowBoundedContent = "_im-d";
export var internal = "_im-5";
export var merchant = "_im-8";
export var messageInputContainer = "_im-h";
export var normal = "_im-7";
export var replyCard = "_im-f";
export var subtleButton = "_im-1";
export var subtleButtonIconContainer = "_im-2";
export var toggleViewRepliesButton = "_im-c";
export var wrappingText = "_im-g";